import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import {
    HIDE_MODAL,
    MODAL_TYPE_REGISTER,
    MODAL_TYPE_LOGIN,
    MODAL_TYPE_LOGIN_FAILED,
    MODAL_TYPE_STAGING_LOGIN,
    MODAL_TYPE_INTERSTITIEL,
    MODAL_TYPE_ADBLOCKER,
    MODAL_TYPE_INFORMATIVE,
    MODAL_TYPE_ALO_DELETE_ACCOUNT,
    MODAL_TYPE_ALO_REACTIVATE_ACCOUNT,
    MODAL_TYPE_PAYMENT_REQUEST_EBON_UNAVAILABLE,
    MODAL_TYPE_KYC
} from '../../services/modal/constants';

import CloseButtonComponent from '../button/CloseButtonComponent';

import AdBlockerModal from '../adblocker/AdBlockerModal';
import InformativeModal from '../informativemodal/InformativeModal';
import LoginFailedModal from '../authentication/login/LoginFailedModal';
import LoginModalComponent from '../authentication/login/LoginModalComponent';
import RegisterModalComponent from '../authentication/register/RegisterModalComponent';
import InterstitielModalComponent from '../pages/interstitiel/InterstitielModalComponent';
import StagingLoginModalComponent from '../authentication/staging/StagingLoginModalComponent';
import AloDeleteAccountModal from '../alo/AloDeleteAccountModal';
import AloReactivateAccountModal from '../alo/AloReactivateAccountModal';
import PaymentRequestEbonUnavailableModal from '../pages/account/cashback/PaymentRequestEbonUnavailableModal';
import KycModal from '../fraud/kyc/KycModal';

import './ModalRoot.scss';

// Chaque nouvelle Modal spécifique doit être ajoutée ici
const MODAL_COMPONENTS = {
    [MODAL_TYPE_REGISTER]: RegisterModalComponent,
    [MODAL_TYPE_LOGIN]: LoginModalComponent,
    [MODAL_TYPE_LOGIN_FAILED]: LoginFailedModal,
    [MODAL_TYPE_STAGING_LOGIN]: StagingLoginModalComponent,
    [MODAL_TYPE_INTERSTITIEL]: InterstitielModalComponent,
    [MODAL_TYPE_ADBLOCKER]: AdBlockerModal,
    [MODAL_TYPE_INFORMATIVE]: InformativeModal,
    [MODAL_TYPE_ALO_DELETE_ACCOUNT]: AloDeleteAccountModal,
    [MODAL_TYPE_ALO_REACTIVATE_ACCOUNT]: AloReactivateAccountModal,
    [MODAL_TYPE_PAYMENT_REQUEST_EBON_UNAVAILABLE]: PaymentRequestEbonUnavailableModal,
    [MODAL_TYPE_KYC]: KycModal
};

const ModalRoot = ({
    modal,
    dispatch,
    location,
    injectCloseButton,
    redirectOnClose,
    redirectToUrl,
    actionOnClose
}) => {
    const hideModal = () => {
        dispatch({ type: HIDE_MODAL });
    };

    if (!modal.modalType) {
        return null;
    }

    const SpecificModal = MODAL_COMPONENTS[modal.modalType];
    const isLarge = modal.modalType === MODAL_TYPE_ADBLOCKER;

    const onCloseButton = () => {
        hideModal();
        if (actionOnClose) {
            actionOnClose();
        }
    };

    const renderCloseButton = () => {
        if (injectCloseButton) {
            if (redirectOnClose && !isEmpty(redirectToUrl)) {
                return (
                    <a href={redirectToUrl}>
                        <CloseButtonComponent onClick={onCloseButton} />
                    </a>
                );
            } else {
                return <CloseButtonComponent onClick={onCloseButton} />;
            }
        }
    };

    const renderBlocker = () => {
        return <div className="blocker" />;
    };

    return (
        <div>
            {renderBlocker()}
            <div
                className={`modal-container flex-container-v flex-center conteneur-mobile ${
                    isLarge ? 'large' : ''
                }`}>
                <div className="modal">
                    <SpecificModal {...modal.modalProps} currentPath={location.pathname} />
                    {renderCloseButton()}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        modal: state.modal,
        injectCloseButton: !state.modal.modalProps || !state.modal.modalProps.hideCloseButton,
        location: state.routing.location,
        redirectOnClose: state.modal.modalProps && state.modal.modalProps.redirectOnClose,
        redirectToUrl: state.modal.modalProps && state.modal.modalProps.redirectToUrl,
        actionOnClose: state.modal.modalProps && state.modal.modalProps.actionOnClose
    };
};

export default connect(mapStateToProps)(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/modal/ModalRoot.js